
export function _get(obj: any, path: string, def: any = null) {
  const fullPath = path
    .replace(/\[/g, '.')
    .replace(/]/g, '')
    .split('.')
    .filter(Boolean)

  return fullPath.every(everyFunc) ? obj : def

  function everyFunc(step: any) {
    return !(step && (obj = obj[step]) === undefined)
  }
}

export function _set(obj: any, path: any, value: any) {
  if (Object(obj) !== obj) {
    return obj
  }

  if (!Array.isArray(path)) {
    path = path.toString().match(/[^.[\]]+/g) || []
  }

  path.slice(0, -1).reduce((a, c, i) => // Iterate all of them except the last one
      Object(a[c]) === a[c] // Does the key exist and is its value an object?
        // Yes: then follow that path
        ? a[c]
        // No: create the key. Is the next key a potential array-index?
        // tslint:disable-next-line:no-bitwise
        : a[c] = Math.abs(path[i + 1]) >> 0 === + path[i + 1]
        ? []
        : {},
    obj)[path[path.length - 1]] = value
  return obj
}

export function enumToSelect(enumObject: any, labelTranslatePath: string = 'select.label'): string[][] {
  return Object
    .keys(enumObject)
    .map(i => ([enumObject[i], `${labelTranslatePath}.${enumObject[i]}`]))
}

export function isEmpty(obj: any): boolean {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}
